import { BlockStack, Card, SkeletonBodyText } from '@shopify/polaris';
import BrandSetting from './components/BrandSetting';
import { CustomerNotification } from './components/CustomerNotification';

interface Props {
  isLoading: boolean;
}

const EmailNotification = ({ isLoading }: Props) => {
  return (
    <BlockStack gap="500">
      {isLoading ? (
        <>
          <Card>
            <SkeletonBodyText lines={9} />
          </Card>
          <Card>
            <SkeletonBodyText lines={9} />
          </Card>
          <Card>
            <SkeletonBodyText lines={9} />
          </Card>
          <Card>
            <SkeletonBodyText lines={9} />
          </Card>
        </>
      ) : (
        <>
          <BrandSetting />
          <CustomerNotification />
        </>
      )}
    </BlockStack>
  );
};

export default EmailNotification;
